export const DB_WebPartDataDemo = []

export const DebugOnePage = false

export default {
    crud_DeleteItem(kendGrid, removeApi) {
        let selectedItems=kendGrid.selectedItemsSystemIds();


        if (selectedItems.length===0){
            alert("請選擇要刪除的資料");
            return;
        }

        removeApi(selectedItems);
    }
}
